import { Sparkles, ArrowRight, Check } from "lucide-react";
import { Reveal, ChapterLabel } from "./Motion";
import { FOUNDING_BENEFITS } from "../../data/content";

const joinFounding = () => {
  window.dispatchEvent(new CustomEvent("heard:founding"));
  document.getElementById("beta")?.scrollIntoView({ behavior: "smooth" });
};

export const FoundingMember = () => (
  <section id="founding" className="bg-cream-deep/60 border-y border-line/60 py-24 sm:py-36">
    <div className="mx-auto max-w-2xl px-6 sm:px-10 text-center">
      <Reveal className="flex justify-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-sage/12 text-sage">
          <Sparkles size={24} strokeWidth={1.6} />
        </span>
      </Reveal>
      <Reveal delay={0.08}>
        <div className="mt-8 flex justify-center"><ChapterLabel index="Founding Circle" /></div>
      </Reveal>
      <Reveal delay={0.12}>
        <h2 className="serif-display mt-6 text-[2rem] sm:text-[2.7rem] lg:text-[3.1rem] font-normal text-charcoal leading-[1.1]">
          Become Part of the Beginning.
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-7 text-lg font-normal sm:font-light leading-[1.9] text-ink/85">
          The first members of HEARD won't just join a community. They'll help shape it.
        </p>
      </Reveal>

      <Reveal delay={0.22}>
        <p className="mt-9 text-sm uppercase tracking-[0.22em] text-sage">As a Founding Circle member you'll receive</p>
      </Reveal>
      <Reveal delay={0.26}>
        <ul className="mx-auto mt-6 grid max-w-md grid-cols-1 gap-3.5 text-left sm:grid-cols-2">
          {FOUNDING_BENEFITS.map((b) => (
            <li key={b} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage-deep">
                <Check size={14} strokeWidth={2.4} />
              </span>
              <span className="text-base font-normal sm:font-light text-ink/85">{b}</span>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.32}>
        <button
          onClick={joinFounding}
          data-testid="founding-cta"
          className="group mt-11 inline-flex items-center gap-2.5 rounded-full bg-sage-deep px-8 py-4 text-sm uppercase tracking-[0.18em] text-cream shadow-[0_12px_30px_rgba(47,75,57,0.24)] transition-all duration-500 hover:bg-sage hover:scale-[1.03]"
        >
          Request Early Access
          <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
